import { createHOC, createRenderFn } from 'vue-hoc';

function withRerender() {
  return (Component) => {
    const options = {
      name: Component.name + '-with-rerender',

      data() {
        return {
          state: {
            rendered: true,
          },
        };
      },
      created() {
        this.renderFn = createRenderFn(Component, {});
      },
      methods: {
        rerender() {
          this.state.rendered = false;
          this.$nextTick(() => {
            this.state.rendered = true;
          });
        },
      },

      render(createElement) {
        if (!this.state.rendered) {
          return null;
        }
        return this.renderFn(createElement);
      },
    };

    const renderWith = {
      props: {},
      listeners: {},
    };

    const AugmentedComponent = createHOC(Component, options, renderWith);
    return AugmentedComponent;
  };
}

export default withRerender;
